import { useQuery } from "@tanstack/react-query";
import type { UseQueryOptions } from "@tanstack/react-query";

import type { GetNoteCosignMetaResponse } from "@/core/types/(api)/cosignature";

import { cosignatureKeys } from "../keyFactory";
import { getNoteCosignMeta } from "../queryFunctions/getNoteCosignMeta";

type UseNoteCosignMetaProps<TData = GetNoteCosignMetaResponse> = {
  documentId: string;
  enabled?: boolean;
  select?: (data: GetNoteCosignMetaResponse) => TData;
};

type NoteCosignMetaQueryOptions = UseQueryOptions<
  GetNoteCosignMetaResponse,
  unknown,
  GetNoteCosignMetaResponse,
  ReturnType<typeof cosignatureKeys.noteMeta>
>;

export function optionFactory(documentId: string, enabled = true) {
  return {
    enabled,
    queryFn: () => getNoteCosignMeta(documentId),
    queryKey: cosignatureKeys.noteMeta(documentId),
  } satisfies NoteCosignMetaQueryOptions;
}

export function useNoteCosignMeta<TData = GetNoteCosignMetaResponse>({
  documentId,
  enabled,
  select,
}: UseNoteCosignMetaProps<TData>) {
  return useQuery({ ...optionFactory(documentId, enabled), select });
}
